export function weightedRandom(variants, random = Math.random) {
    // <https://en.wikipedia.org/wiki/Reservoir_sampling#Algorithm_A-Res>,
    // but specialized to k=1, where the priority queue degenerates to just a variable and comparison
    let acc = null;
    for (const [value, weight] of variants) {
        const key = Math.pow(random(), 1 / weight);
        if (!acc || key > acc[1]) {
            acc = [value, key];
        }
    }
    if (!acc) {
        throw new Error("Empty list of variants");
    }
    return acc[0];
}
